<template>
  <div>
    <!-- Messages -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature7"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Multivers
      </h3>
      <p data-scroll class="mdc-typography--body text-color font-weight-bold">
        Partajează fișiere media, vezi când prietenii tăi tastează și bucură-te
        de chat-uri de grup mai bune.
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content py-5 always-white">
            <h6
              class="mdc-typography--headline6 text-color zindex-dropdown position-relative"
              style="z-index:3;"
            >
              Un mod simplu de a comunica prin voce, video și text.
            </h6>
            <p
              class="typography-phrase position-relative phrase"
              style="z-index:3;"
            >
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="300"
                >Lucrați
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="500"
                >de la
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="700"
                >distanță
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="900"
                >fără
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1000"
                >să vă
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1200"
                >simțiți
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="500"
                data-aos-delay="1500"
                >la distanță.</span
              >
            </p>
            <!-- <figure class="image-feature1-item1" role="img"></figure> -->
            <figure
              class="front-panel-bgimage image-working-remote progressive-image-animated"
              data-progressive-image-loaded
            ></figure>
            <div class="backdrop-filter" style="z-index:2;"></div>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Colaborați de oriunde
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Conectați-vă cu universul
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Universuri sau Servere
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Alătură-te sau crează propriul univers
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Messages: 'Messages'
}
</script>

<style>
.typography-phrase {
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 182px;
  margin-bottom: 107px;
  text-align: center;
}
.word {
  font-size: 56px;
  line-height: 1.07143;
  font-weight: 700;
  letter-spacing: -0.005em;
  font-family: 'SF Pro Display', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
    'Arial', sans-serif;
  position: relative;
}
.image-working-remote {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/messages/working-remote.jpg);
  background-position: center;
  background-size: cover;
}

.backdrop-filter {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.35);
  /* backdrop-filter: saturate(180%) blur(20px); */
}
</style>
